import { render, staticRenderFns } from "./AppPoster.vue?vue&type=template&id=5c02e1a6&scoped=true"
import script from "./AppPoster.vue?vue&type=script&lang=js"
export * from "./AppPoster.vue?vue&type=script&lang=js"
import style0 from "./AppPoster.vue?vue&type=style&index=0&id=5c02e1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02e1a6",
  null
  
)

export default component.exports